import React from "react";
import "./VisitorCmAllocation.css";

const CM_ACTION_BTN_CLASS =
  "cm-alloc-cell__action cm-alloc-cell__action--btn";

/**
 * GRE/CTL table cell for CM allocation.
 * state: "allocated" | "pending" | "inactive"
 */
const VisitorCmAllocationCell = ({
  state,
  cmName = "",
  disabled = false,
  onAllocate,
  onReallocate,
  strings,
}) => {
  if (state === "inactive") {
    return (
      <div className="cm-alloc-cell cm-alloc-cell--minimal">
        <div className="cm-alloc-cell__slot cm-alloc-cell__slot--empty">
          <span className="cm-alloc-cell__empty">—</span>
        </div>
      </div>
    );
  }

  if (state === "allocated") {
    const displayName = cmName || "—";
    const allocatedTitle = `${
      strings.currentlyAllocatedTo || "Currently allocated to"
    } ${displayName}`;

    return (
      <div className="cm-alloc-cell cm-alloc-cell--minimal">
        <div className="cm-alloc-cell__slot">
          <button
            type="button"
            className={CM_ACTION_BTN_CLASS}
            disabled={disabled}
            onClick={onReallocate}
            title={`${allocatedTitle}. ${strings.reassignToCM || "Reassign"}`}
          >
            {strings.reassignToCM || "Reassign"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="cm-alloc-cell cm-alloc-cell--minimal">
      <div className="cm-alloc-cell__slot">
        <button
          type="button"
          className={CM_ACTION_BTN_CLASS}
          disabled={disabled}
          onClick={onAllocate}
          title={strings.selectNewClosingManager}
        >
          {strings.allocate}
        </button>
      </div>
    </div>
  );
};

export default VisitorCmAllocationCell;
